<template>
<div>
	<h1>404 Error </h1>
	<h4>The page you are looking for doesn't exists</h4>
</div>
</template>

<script>
export default {
	data() {
		return {
			metadata: {
				section: "error",
				title: "404"
			}
		}
	},
	methods: {
		loadToParent: function() {
			this.$emit("data-to-parent", this.metadata);
		}
	},
	mounted: function() {
		this.loadToParent();	
	},
}
</script>
